
export function parseGraphQLResponse<T>(response: GraphQLResponse<T>, isSingle: boolean = true): T[] {
  /** extract first key from response. ie the query name */
  const [queryName, raw] = Object.entries(response.data)[0] || [];

  if (!queryName || !raw) {
    const error = new Error("Invalid GraphQL response structure");
    (error as any).rawResponse = response;
    throw error;
  }
  const parsed = typeof raw === "string" ? JSON.parse(raw) : raw;

  if (!parsed) {
    const error = new Error(`Empty response for ${queryName}`);
    (error as any).rawResponse = response;
    throw error;
  }

  // Handle different response formats
  const isSuccess = parsed.status === 200 || parsed.status === "SUCCESS" || parsed.status === "put_object";

  if (!isSuccess || parsed.error?.length) {
    if (parsed.status === 400) {
      console.error("No data found", parsed);
      const error = new Error(parsed.data.ERROR);
      (error as any).rawResponse = response;
      throw error;
    }
    const errorMessage = parsed.error?.map(e => e.ERROR).join("\n") || `Unknown error for: ${queryName}`;
    console.error(errorMessage, parsed);
    const error = new Error(errorMessage);
    (error as any).rawResponse = response;
    throw error;
  }

  // Handle createSignedUrl response format
  if (queryName === "createSignedUrl" && parsed.url) {
    return parsed;
  }

  const result = isSingle ? parsed.data[0] : parsed.data;

  // Convert Unix timestamps to date strings for form compatibility
  if (Array.isArray(result)) {
    return result;
  }

  return result;
}
